/**
 * TP-only path keys (stripped before PUT) + read helpers.
 */

import type {
  VoluumCalculationMethod,
  VoluumPathUpdate,
} from '@trafficpulse/shared';

export const TP_PATHS_DISTRIBUTION_AI_KEY = '__tpPathsDistributionAi' as const;
export const TP_OFFERS_LANDERS_AI_KEY = '__tpOffersLandersAi' as const;
export const TP_PATHS_CALCULATION_METHOD_KEY =
  '__tpPathsCalculationMethod' as const;
export const TP_OFFERS_CALCULATION_METHOD_KEY =
  '__tpOffersLandersCalculationMethod' as const;

export function readTpFlag(
  p: VoluumPathUpdate,
  key: typeof TP_PATHS_DISTRIBUTION_AI_KEY | typeof TP_OFFERS_LANDERS_AI_KEY,
): boolean | undefined {
  const v = p[key];
  return typeof v === 'boolean' ? v : undefined;
}

function isCalcMethod(v: unknown): v is VoluumCalculationMethod {
  return v === 'AUTO' || v === 'ROI' || v === 'EPV' || v === 'CVR';
}

export function readTpCalc(
  p: VoluumPathUpdate,
  key:
    | typeof TP_PATHS_CALCULATION_METHOD_KEY
    | typeof TP_OFFERS_CALCULATION_METHOD_KEY,
): VoluumCalculationMethod | undefined {
  const v = p[key];
  return isCalcMethod(v) ? v : undefined;
}

export function baseCalculationMethod(
  p: VoluumPathUpdate,
): VoluumCalculationMethod {
  return (p.calculationMethod ?? 'AUTO') as VoluumCalculationMethod;
}
